import {createApp} from "vue";
import App from "./App";
import i18n from "./i18n";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/app.css";
import router from "./router";
import './validation';

import { Field, Form, configure} from "vee-validate";

// Kan tas bort när vi gått över helt till vue 3
const veeValidateExtraConfig = {
    compatConfig: { MODE: 3 }
};

configure({
    bails: false,
    validateOnInput: true
});

createApp(App)
    .use(i18n)
    .use(BootstrapVue)
    .use(IconsPlugin)
    .use(router)
    .component("Field", {...Field, ...veeValidateExtraConfig})
    .component("Form", {...Form, ...veeValidateExtraConfig})
    .mount("#app");